<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{
      disabled: user.nickName !== formState.promoter,
    }"
    width="800px"
  >
    <a-form
      :model="formState"
      ref="formRef"
      :rules="rules"
      :label-col="{ span: 3 }"
    >
      <a-form-item label="流程名称" name="processName">
        <a-textarea
          v-model:value="formState.processName"
          placeholder="请输入流程名称"
          auto-size
        ></a-textarea>
      </a-form-item>

      <approve-node
        v-if="modalConfig.visible"
        :echoApprove="formState.nodes"
        :echoRecord="formState"
        ref="approveNodeRef"
      ></approve-node>

      <a-form-item label="附件" name="annex">
        <upload
          :echoFile="formState.annex"
          @setUploadFileUrl="setUploadFileUrl"
        ></upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
   
<script>
import { defineComponent, nextTick, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  updateDesignChanges,
  insertDesignChanges,
} from "@/request/view/project";

import upload from "@/views/rdmanagement/components/database/upload.vue";
import approveNode from "@/views/rdmanagement/components/ena/approveNode.vue";
import { Toast, debounce } from "@/utils";

export default defineComponent({
  components: { upload, approveNode },
  setup(props, context) {
    const route = useRoute();
    const user = useStore().state.user.user;

    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const approveNodeRef = ref();

    const formState = reactive({
      processName: null,
      projectLifeCycle: null,
      projectLifeCycleId: null,
      promoter: null,
      nodes: null,
      annex: null,
      id: null,
      isEnd: false,
    });

    const rules = {
      processName: [
        {
          required: true,
          message: "请输入流程名称",
          trigger: "blur",
          type: "any",
        },
      ],
    };

    // 上传文件
    const setUploadFileUrl = (url) => {
      formState.annex = url;
    };

    const formRef = ref();

    // 初始化新增表单数据
    const setInsertFormData = () => {
      formState.promoter = user.nickName;
      formState.projectLifeCycle = route.query.projectLifeCycle;
      formState.projectLifeCycleId = route.query.projectId;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const setEchoFormData = (data) => {
      Object.keys(formState).forEach((key) => {
        formState[key] = data[key];
      });
    };

    const showModal = (options) => {
      const { title, data, type } = options;
      modalConfig.visible = true;
      modalConfig.title = title;
      modalConfig.type = type;
      if (type === "insert") setInsertFormData();
      if (type === "update") setEchoFormData(data);
      nextTick(() => {
        approveNodeRef.value.setApprovelist();
      });
    };

    const closeModal = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.type = null;
    };

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          formState.nodes = approveNodeRef.value.approveList;
          let reqFn =
            modalConfig.type === "insert"
              ? insertDesignChanges
              : updateDesignChanges;

          reqFn(formState).then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            closeModal();
            context.emit("updateTable");
          });
        })
        .catch((err) => {});
    });

    const handleCancel = () => {
      closeModal();
    };

    return {
      user,
      modalConfig,
      handleOk,
      showModal,
      closeModal,
      handleCancel,
      setUploadFileUrl,
      formState,
      formRef,
      rules,
      approveNodeRef,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>